import Path from '../../../services/paths'
import utils from '../../common/utils'
import PromotionAction from '../../prat_actions/gt/promotionAction'
import axios from 'axios';
import CustomToast from '../../../util-functions/customToast';
import {getCookie} from '../../../util-functions/util-funtions'


export default class PromotionMiddleware {
    static get_promotionType(){
        return dispatch => {
            dispatch(PromotionAction.promotionType_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_PROMOTION_TYPE , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    if (
                        data.detail === "Authentication credentials were not provided."
                      ) {
                        localStorage.clear();
                        window.location.reload();
                      }
                    dispatch(PromotionAction.promotionType_Success(data))
                })
                .catch(err => {
                    dispatch(PromotionAction.promotionType_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(PromotionAction.promotionType_Failed(err.message))

            })
        }
    }

    // promotion level

    static get_promotionLevel(formType){
      let url = Path.GET_PROMOTION_LEVEL;
      if(formType === 'ic'){
        url += `?is_icecream=1`;
      }
        return dispatch => {
            dispatch(PromotionAction.promotionLevel_Request());
            utils.get_token()
            .then(token => {
                fetch(url , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    // if (
                    //     data.detail === "Authentication credentials were not provided."
                    //   ) {
                    //     AuthMiddleware.refreshToken(user.refresh_token)
                    //   }
                    dispatch(PromotionAction.promotionLevel_Success(data))
                })
                .catch(err => {
                    dispatch(PromotionAction.promotionLevel_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(PromotionAction.prat1Failed(err.message))

            })
        }
    }

    static get_AllPromotionType(){
        return dispatch => {
            dispatch(PromotionAction.promotionType_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_ALL_PROMOTION_TYPE, {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    if (
                        data.detail === "Authentication credentials were not provided."
                      ) {
                          localStorage.clear();
                        window.location.reload();
                      }
                    dispatch(PromotionAction.promotionType_Success(data))
                })
                .catch(err => {
                    dispatch(PromotionAction.promotionType_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(PromotionAction.prat1Failed(err.message))

            })
        }
    }
    
    static downloadPromoCSV(
        id,
      ) {
        let url = `${Path.BASE_URL}/activity/preopso/${id}/export/`;

        return dispatch => {
          dispatch(PromotionAction.downlaod_promo_csv_Request());
    
          utils
            .get_token()
            .then(token => {
              axios({
                method: "GET",
                url: url,
                responseType: 'blob',
                headers: {
                  "Content-Type": "text/csv",
                  Authorization: `Bearer ${token}`
                }
              })
                .then(res => {
                  if (res.status === 200) {
                    let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1)
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    CustomToast('success', 'Download Successful')
                    dispatch(PromotionAction.downlaod_promo_csv_Success(res));
                  } else {
                    CustomToast('error', 'Download Failed!')
                    dispatch(PromotionAction.downlaod_promo_csv_Failed('error'));
                  }
                })
                .catch(error => {
                  CustomToast('error', 'Download Failed!')
                  dispatch(PromotionAction.downlaod_promo_csv_Failed(error));
                });
            })
            .catch(error => {
              dispatch(PromotionAction.downlaod_promo_csv_Failed(error));
            });
        };
      }  
    
      static calculatePreopsoFromCSV(id,data){
        const csrftoken = getCookie('csrftoken');
          return dispatch => {
              dispatch(PromotionAction.calculate_promo_csv_Request());
              utils.get_token()
              .then(token => {
                  axios({
                      method: 'POST',
                      url: Path.BASE_URL+`/activity/preopso/${id}/csv_calculate/`,
                      headers: {
                          "Content-type": "application/json",
                          Authorization: `Bearer ${token}`,
                          'X-CSRFToken': csrftoken
                      },
                      data: JSON.stringify(data)
                  })
                  .then(data => {
                    if(data.status === 200){
                      dispatch(PromotionAction.calculate_promo_csv_Success(data))
                    }
                    else{
                      dispatch(PromotionAction.calculate_promo_csv_Failed(data))
                    }
                  })
                  .catch(err => {
                      dispatch(PromotionAction.calculate_promo_csv_Failed(err.message))
                  })
              })
              .catch(err => {
                  dispatch(PromotionAction.calculate_promo_csv_Failed(err.message))
  
              })
          }
      };
    
}

